import React from "react";
import './style.scss';

const Loader = () => {
    return (
        <div className="loader">
            <img src={require('@images/spinner.svg')} alt="..."/>
        </div>
    )
}

export default Loader;